// pages/Dashboard.jsx
import DashboardLayout from "../../components/dashboard/DashboardLayout";
import BookSuggestionManager from "../../components/dashboard/BookSuggestionManager";

export default function Dashboard() {
  return (
    <DashboardLayout>
      <BookSuggestionManager />
    </DashboardLayout>
  );
}
